
























import Component from 'vue-class-component'
import Vue from 'vue'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
})
export default class PaginationV2 extends Vue {
  get isNextDisabled () {
    return this.$props.page * this.$props.pageSize >= this.$props.total
  }

  get isPrevDisabled () {
    return this.$props.page === 1
  }
}
